import React, { createContext, useContext, useState } from 'react';

const FloatingCartContext = createContext();

export function FloatingCartProvider({ children }) {
  const [isOpen, setIsOpen] = useState(false);

  const toggleCart = () => {
    setIsOpen(!isOpen);
  };

  const openCart = () => {
    setIsOpen(true);
  };

  const closeCart = () => {
    setIsOpen(false);
  };

  return (
    <FloatingCartContext.Provider value={{ isOpen, toggleCart, openCart, closeCart }}>
      {children}
    </FloatingCartContext.Provider>
  );
}

export function useFloatingCart() {
  const context = useContext(FloatingCartContext);
  if (!context) {
    throw new Error('useFloatingCart must be used within FloatingCartProvider');
  }
  return context;
}
